import { Injectable } from '@angular/core';

import { ApiService }                              from '../api/api.service';
import { CodeTypeModel }                           from '../core/models/code-type';
import { CommunicationCenterContactModel }         from './typings/communication-center.contact';
import { CommunicationCenterFiltersModel }         from './typings/communication-center.filters';
import { CommunicationCenterMessagesModel }        from './typings/communication-center.messages';
import { CommunicationCenterSelectedContactModel } from './typings/communication-center.selected-contact';;
import { CustomerSourceModel }                     from '../company-lists/typings/customer-source';
import { TableQueryParameters }                    from '../table/types/table-query-parameters';

@Injectable({
  providedIn: 'root'
})
export class CommunicationCenterService {
  public tableCacheKey = 'communicationCenterContacts'

  constructor (
    private apiService: ApiService
  ) {}

  getContacts ( filters : CommunicationCenterFiltersModel, params : TableQueryParameters ) : ng.IPromise<Array<CommunicationCenterContactModel>> {
    return this.apiService.get('/communication_centre/communication_filter_search', [
      filters.contactType,
      filters.communicationType,
      filters.fromPostcode   || '*',
      filters.toPostcode     || '*',
      filters.make           || '*',
      filters.model          || '*',
      filters.buildYear      || '*',
      filters.customerSource || '*',
      filters.lastInFrom     || '*',
      filters.lastInTo       || '*',
      params.offset          || 0,
      params.pageSize        || 10,
      params.field           || 'display_name',
      params.direction       || 'asc'
    ]);
  }

  getContactsCount ( filters : CommunicationCenterFiltersModel ) : ng.IPromise<number> {
    return this.apiService.get('/communication_centre/search_count', [
      filters.contactType,
      filters.communicationType,
      filters.fromPostcode   || '*',
      filters.toPostcode     || '*',
      filters.make           || '*',
      filters.model          || '*',
      filters.buildYear      || '*',
      filters.customerSource || '*',
      filters.lastInFrom     || '*',
      filters.lastInTo       || '*'
    ]);
  }

  getContactTypes () : ng.IPromise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/communication_contact_types');
  }

  getCustomerSources () : ng.IPromise<Array<CustomerSourceModel>> {
    return this.apiService.get('/customer_sources', null, 'customerSources');
  }

  getDocumentURL () : string {
    return `${ this.apiService.getEndpoint() }/reports/jasper_service_reminders.pdf`;
  }

  getTypes () : ng.IPromise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/communication_types');
  }

  send ( commMessages : CommunicationCenterMessagesModel, contacts : Array<CommunicationCenterSelectedContactModel>, filters : CommunicationCenterFiltersModel ) : ng.IPromise<any> {
    return this.apiService.post('/communication_centre/request_send_communication', {
      comm_messages     : commMessages,
      communication_type: filters.communicationType,
      contact_type      : filters.contactType,
      customer_list     : contacts
    });
  }
}
